import { useContext } from 'react';
import { TenantContext } from '../../../context/tenant-context';
import { handleRequest } from '../quipli-service-client';
import { Country, SearchCountriesRequest, SearchStateProvincesRequest, StateProvince } from './locales';

export const useLocalesAPI = () => {
  const { tenant, contextPath } = useContext(TenantContext);

  async function searchCountries(request: SearchCountriesRequest): Promise<Country[]> {
    const config = {
      method: 'post',
      url: `${contextPath}quipli-service/v1/locales/countries`,
      headers: {
        'X-Tenant': tenant,
      },
      data: request,
    };
    return await handleRequest<Country[]>(config);
  }

  async function searchStateProvinces(request?: SearchStateProvincesRequest): Promise<StateProvince[]> {
    const config = {
      method: 'post',
      url: `${contextPath}quipli-service/v1/locales/state-provinces`,
      headers: {
        'X-Tenant': tenant,
      },
      data: request,
    };
    return await handleRequest<StateProvince[]>(config);
  }

  return {
    searchCountries,
    searchStateProvinces,
  };
};
